import React from 'react'
import './styles.css';

function FileDisplay(props) {
  const handleSelect = ()=>{
    props.onClick();
  }
  return (
    <div id='file-list'>
        <div id = "file" onClick={handleSelect}>{props.value}</div>
    </div>
  )
}

export default FileDisplay